import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Suppression des tokens du localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    
    // Redirection vers la page de connexion
    navigate('/login');
  }, [navigate]);

  return (
    <div>
      <h2>Déconnexion...</h2>
    </div>
  );
}

export default Logout;
